export default __webpack_public_path__ + "static/media/refresh-fill.0991e2f0.svg";